module.exports = __webpack_public_path__ + "media/images/help-1c12121b29865a56a98dae255a28c6d7.svg";